import { SET_MAX_ORDER_QTY } from "actions/types";
import axios from "api/axiosInstance";
import API_LIST from "./apiList";
import SystemConstant from "constants/SystemConstant";
import { setAlert } from "./appActions";

/** API returns { [brand_id]: row } — normalize to a single row object. */
export function getMaxOrderQtyRow(data) {
  if (!data) {
    return null;
  }

  if (Array.isArray(data)) {
    return data[0] ?? null;
  }

  if (typeof data === "object" && data.allowed_qty !== undefined) {
    return data;
  }

  if (typeof data === "object") {
    return (
      Object.values(data).find(
        (value) =>
          value &&
          typeof value === "object" &&
          value.allowed_qty !== undefined
      ) ?? null
    );
  }

  return null;
}

export function normalizeMaxOrderQtyResponse(data) {
  const row = getMaxOrderQtyRow(data);
  return row ? [row] : [];
}

/** Remaining purchasable qty (allowed minus prior orders). Null = no limit configured. */
export function getRemainingMaxOrderQty(data) {
  const row = getMaxOrderQtyRow(data);
  if (!row) {
    return null;
  }

  const allowed = Number(row.allowed_qty);
  if (!Number.isFinite(allowed) || allowed <= 0) {
    return null;
  }

  const ordered = Number(row.ordered_qty) || 0;
  return Math.max(allowed - ordered, 0);
}

export function getMaxOrderQty(cust_id, brand_id) {
  return (dispatch) => {
    // const headers = SystemConstant.adminRequestHeaders; 
    const access_code = SystemConstant.cookies.get("access_code");
    const postBody = {
      customer_id: cust_id,
      brand_id: brand_id,
      access_id: access_code
    };

    const headers = SystemConstant.getUserRequestHeaders();
    headers["x-publishable-api-key"] = process.env.REACT_APP_X_PUBLISHER_API_KEY;


    return axios
      .post(API_LIST.maxOrderQty, postBody, { headers })
      .then((res) => {
        if (res.data) {
          const normalized = normalizeMaxOrderQtyResponse(res.data);
          dispatch(getMaxOrderQtySuccess(normalized));
          return normalized;
        } else {
          dispatch(
            setAlert(
              `${SystemConstant.somethingWentWrongText}`,
              SystemConstant.warning
            )
          );
          return null;  // Return null if no data
        }
      })
      .catch(() => {
        dispatch(
          setAlert(
            `${SystemConstant.somethingWentWrongText}`,
            SystemConstant.warning
          )
        );
        return null;  // Return null in case of an error
      });
  };
}

export async function getMaxOrderQtyPerCategory(cust_id, brand_id) {
  const headers = SystemConstant.adminRequestHeaders;
  const access_code = SystemConstant.cookies.get("access_code");
  const postBody = {
    customer_id: cust_id,
    brand_id: brand_id,
    accessId: access_code
  };
  return new Promise((resolve, reject) => {
    axios
      .post(API_LIST.maxOrderQty, postBody, { headers })
      .then((res) => {
        if (res.data) {
          resolve(normalizeMaxOrderQtyResponse(res.data));
        } else {
          console.error("problem with max order qty action");
          reject("problem with max order qty action");
        }
      })
      .catch(() => {
        console.error("problem with max order qty action");
        reject("problem with max order qty action");
      });
  });
}

export function getMaxOrderQtySuccess(response) {
  return {
    type: SET_MAX_ORDER_QTY,
    payload: response,
  };
}
